export const statisticAuctionItemsStyle = {
	wrapper: {
		width: '100%',
		height: '100%',
		overflow: 'inherit',
	},

	searchButton: {
		textTransform: 'inherit',
		width: '200px',

		'& svg': {
			width: '24px',
			height: '24px',

			'& path': {
				fill: 'var(--default-white)',
			},
		},
	},

	tableContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 46px)',
	},

	container: {
		marginBottom: '40px',
	},

	table: {
		maxWidth: '1074px',
		tableLayout: 'fixed',
	},

	tableHeader: {
		'& > :nth-of-type(1)': {
			textTransform: 'uppercase',
			width: '6%',
		},
		'& > :nth-of-type(2)': {
			paddingLeft: '60px !important',
			width: '45%',
		},
		'& > :nth-of-type(3)': {
			width: '6%',
		},
		'& > :nth-of-type(4)': {
			width: '9%',
		},
		'& > :nth-of-type(5)': {
			width: '9%',
		},
		'& > :nth-of-type(6)': {
			width: '9%',
		},
		'& > :nth-of-type(7)': {
			width: '9%',
		},
		'& > :nth-of-type(8)': {
			width: '9%',
		},
	},

	tableBody: {
		'& > :nth-of-type(1)': {
			fontSize: '12px',
		},

		'& .MuiTableCell-root': {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			height: '48px',
			paddingTop: '8px !important',
			paddingBottom: '8px !important',
		},
	},

	headerCell: {
		display: 'flex',
	},

	headerCellTitle: {
		maxWidth: '57px',
		display: 'block',
		textAlign: 'right',
		color: 'var(--neutral-500)',
	},

	bodyCell: {
		display: 'flex',
		gap: '12px',
	},

	bodyCellImage: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: 'var(--neutral-100)',
		width: '48px',
		height: '48px',
		flexShrink: 0,
		borderRadius: '4px',

		svg: {
			height: '24px',
			width: '24px',

			path: {
				fill: 'var(--neutral-300)',
			},
		},

		marginLeft: '-8px',
		'& img': {
			width: '48px !important',
			height: '48px !important',
			borderRadius: '4px',
		},
	},

	bodyCellImageContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},

	bodyCellImageContentName: {
		fontSize: '16px !important',
		fontWeight: '700 !important',
	},

	bodyCellImageContentCategory: {
		color: 'var(--neutral-300) !important',
	},

	loader: {
		position: 'absolute',
		left: 'calc(50% - 25px)',
		top: '200px',
	},

	pagination: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginRight: '16px',
		marginBottom: '48px',
	},
};
